<template>
  <div class="chartWidget">
    <!-- Settings trigger -->
    <a
      href="#"
      class="chartWidget__settingsShowTrigger"
      v-b-tooltip.hover
      title="Chart Settings"
      @click.prevent="showSettings"
      v-if="$can('update', 'Dashboard_' + currentDash)"
    >
      <icon name="cog" scale="1.5" />
    </a>
    <!-- Settings -->
    <div
      class="chartWidget__settings bg-gradient-default p-3"
      v-if="chartComponentsSettingsShown[chartId] && $can('update', 'Dashboard_' + currentDash)"
    >
      <div class>
        <a
          class="chartWidget__settingsHideTrigger"
          href="#"
          title="Hide Settings"
          @click.prevent="hideSettings"
        >
          <icon name="remove" :inverse="true" />
        </a>
        <!-- Tabs -->
        <div class="row d-flex">
          <ul class="nav nav-pills col-12 px-3 nav-fill flex-column flex-sm-row">
            <li class="nav-item mb-1" v-for="(type, key) in chartTypes" :key="key">
              <a
                class="nav-link px-2 py-1"
                :class="[chartType === type ? 'active' : '']"
                href="#"
                @click.prevent="setActive(type)"
              >{{ type | capitalize }}</a>
            </li>
          </ul>
          <div class="col-sm-6 mb-2">
            <label class="h4 text-white">Label</label>
            <div v-for="(em, key1) in labelNewForChart" :key="key1">
              <select
                v-model="labelForChart"
                class="form-control mb-2 p-1"
                @change="optionsItemChanged"
              >
                <option class="option" v-for="(e, key2) in em" :key="key2" :value="e">{{e}}</option>
              </select>
              <select
                v-model="label2ForChart"
                class="form-control p-1"
                v-bind:class="{'d-none': (chartType != 'stacked' && chartType != 'multiple' && chartType != 'line' && chartType != 'area') }"
                @change="optionsItemChanged"
              >
                <option class="option" v-for="e in em" :value="e" :key="e">{{e}}</option>
              </select>
            </div>
          </div>
          <div class="col-sm-6 mb-2">
            <label class="h4 text-white">Data</label>
            <div v-for="(em, key1) in dataNewForChart" :key="key1">
              <select v-model="dataForChart" class="form-control p-1" @change="optionsItemChanged">
                <option class="option" v-for="(e, key2) in em" :key="key2" :value="e">{{ e }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Chars -->
    <div class="chartWidget__chartWrapper" ref="chartWrapper">
      <PieChart
        :chart-data="dataByDefualt"
        :options="optionsByPie"
        v-if="chartType === 'pie'"
      />
      <BarChart
        :chart-data="dataByDefualt"
        :options="optionsByBar"
        v-if="chartType === 'bar'"
      />
      <DonutChart
        :chart-data="dataByDefualt"
        :options="optionsByDonut"
        v-if="chartType === 'donut'"
      />
      <StackedBarChart
        :chart-data="dataByStacked"
        :options="optionsByStacked"
        v-if="chartType === 'stacked'"
      />
      <MultipleChart
        :chart-data="dataByStacked"
        :options="optionsByMultiple"
        v-if="chartType === 'multiple'"
      />
      <LineChart
        :chart-data="dataByLine"
        :options="optionsByLine"
        v-if="chartType === 'line' || chartType === 'area'"
      />
      <Table
        :chart-data="label"
        :options="optionsByTable"
        v-if="chartType === 'table'" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { groupBy, sumBy, fill, forEach, map } from 'lodash'
import 'chartjs-plugin-datalabels'
import PieChart from './pie.js'
import BarChart from './bar.js'
import DonutChart from './donut.js'
import LineChart from './line.js'
import StackedBarChart from './stackedBar'
import MultipleChart from './multiple'
import Table from './table'

import randomColor from 'randomcolor'
// services
import db from '@/services/db'
import { setTimeout } from 'timers'
import { mapState } from 'vuex'

const $ = window.$

export default {
  components: {
    PieChart,
    BarChart,
    DonutChart,
    StackedBarChart,
    LineChart,
    MultipleChart,
    Table,
  },
  props: {
    rData: {
      type: Array,
      required: true,
    },
    chartId: {
      type: String,
      required: true,
    },
    widgetKey: {
      type: String,
      required: true,
    },
    gridId: {
      type: String,
    },
  },
  data() {
    return {
      height: 100,
      reportData: this.rData,
      dataForChart: null,
      settingsShown: false,
      labelForChart: null,
      label2ForChart: null,
      dataByDefualt: null,
      dataByLine: null,
      dataByStacked: null,
      optionsByPie: null,
      optionsByBar: null,
      optionsByLine: null,
      optionsByStacked: null,
      optionsByMultiple: null,
      optionsByDonut: null,
      dataNewForChart: [],
      labelNewForChart: [],
      labellabel: [],
      isPie: false,
      isDonut: false,
      isBar: false,
      isStacked: false,
      isMultiple: false,
      isLine: false,
      isTable: false,
      chartType: '',
      chartTypes: [
        'pie',
        'bar',
        'donut',
        'stacked',
        'line',
        'multiple',
        'table',
        'area',
      ],
      rows: [],
      label: [],
      labelStacked: [],
      dataStacked: [],
      data: [],
      background: [],
      colors: [
        '#fb6340', //orange
        '#f5365c', //succsess
        '#2dce89', //green
        '#11cdef', //blue
        '#5e72e4', //primary
        '#ff9f40',
        '#36a2eb',
        '#ff6384',
        '#ffcd56',
        '#4bc0c0',
        '#6f40fe',
      ],
      legend: {
        display: false,
        fullWidth: true,
        position: 'top',
        labels: {
          fontColor: '#8898aa',
          usePointStyle: true,
          padding: 10,
        },
      },
      yAxes: {
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: '#dee2e6',
          drawBorder: false,
          drawTicks: false,
          lineWidth: 0,
          zeroLineWidth: 0,
          zeroLineColor: '#dee2e6',
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
        },
        ticks: {
          fontColor: '#8898aa',
          beginAtZero: true,
          padding: 10,
          callback: function(value) {
            if (!(value % 10)) {
              return value
            }
          },
        },
      },
      xAxes: {
        gridLines: {
          drawBorder: false,
          drawOnChartArea: false,
          drawTicks: false,
        },
        ticks: {
          autoSkip: false,
          fontColor: '#8898aa',
          padding: 20,
        },
        barPercentage: 0.7,
        maxBarThickness: 15,
      },
      isReady: true,
    }
  },
  watch: {
    labelForChart() {
      this.checkIsRequiredDataFilled()
    },
    dataForChart() {
      this.checkIsRequiredDataFilled()
    },
    label2ForChart() {
      this.checkIsRequiredDataFilled()
    },
    currentTab() {
      this.adjustChartSize()
    },
  },
  computed: {
    ...mapState([
      'currentDash',
      'chartComponentsSettingsShown',
      'currentTab',
      'dataGrid_options',
      'currentTemplate',
    ]),
  },
  methods: {
    adjustChartSize() {
      this.$nextTick(() => {
        const parentHeight = $(this.$refs.chartWrapper).closest('.widgetContent').height()

        $(this.$refs.chartWrapper)
          .find('canvas')
          .height(parentHeight)
      })
    },
    showSettings() {
      const vm = this
      this.$store.commit('toggleChartComponentsSettingsShown', {
        chartId: vm.chartId,
        val: true,
      })
    },
    hideSettings() {
      const vm = this
      this.$store.commit('toggleChartComponentsSettingsShown', {
        chartId: vm.chartId,
        val: false,
      })
    },
    checkIsRequiredDataFilled() {
      if (this.labelForChart && this.dataForChart && this.label2ForChart) {
        this.isReady = true
        this.fillData()
      } else {
        this.isReady = false
      }
    },
    optionsItemChanged() {
      const vm = this
      const data = {
        label: vm.labelForChart,
        label2: vm.label2ForChart || vm.labelForChart,
        data: vm.dataForChart,
      }
      db.chart.setNewLablesAndData(this.chartId, data)
    },
    loadData() {
      if (this.colors.length < this.rData.length) {
        let count = this.rData.length - this.colors.length
        let color = randomColor({
          count: count,
          luminosity: 'light',
          hue: 'random',
        })
        this.colors = this.colors.concat(color)
      }
    },
    filterByDropdown() {
      if (this.gridId) {
        const meta = this.dataGrid_options[this.gridId]
          ? this.dataGrid_options[this.gridId].meta
          : null

        if (meta) {
          const fieldList = []

          for (let cellKey in meta) {
            fieldList.push(cellKey)
          }

          this.labelNewForChart.push(fieldList)
          this.dataNewForChart.push(fieldList)
        }
      } else {
        let dataFirstRow = this.reportData[0]

        if (dataFirstRow) {
          let fieldList = Object.keys(dataFirstRow)

          this.labelNewForChart.push(fieldList)
          this.dataNewForChart.push(fieldList)
        }
      }
    },
    fillWithEmpty(data, labels, labelTofill) {
      let filledData = {}
      let valuesToFill = []
      let filledLabels = []
      let valueType
      try {
        valueType = labelTofill.split('$')[2]
      } catch (e) {
        valueType = 'none'
      }

      const fillMonths = () => {
        return [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ]
      }
      const fillYears = years => {
        const yearsFilled = []
        const maxYear = Math.max(...years)
        const minYear = Math.min(...years)
        for (let i = minYear; i <= maxYear; i++) {
          yearsFilled.push(i + '')
        }
        return yearsFilled
      }
      if (valueType === 'Month') {
        valuesToFill = fillMonths()
      } else if (valueType === 'Year') {
        valuesToFill = fillYears(Object.keys(data).filter(el => !isNaN(+el)))
      } else if (valueType === 'MonthYear') {
        const years = fillYears(
          Object.keys(data)
            .map(el => el.split(' ')[1])
            .filter(el => !isNaN(+el))
        )
        const months = fillMonths()
        years.forEach(el => {
          months.forEach(item => {
            valuesToFill.push(`${item} ${el}`)
          })
        })
      } else if (valueType === 'YearWeek') {
        const years = fillYears(
          Object.keys(data)
            .map(el => el.split('/')[0])
            .filter(el => !isNaN(+el))
        )
        const weeks = Array.apply(null, Array(52)).map((el, i) => i + 1)
        years.forEach(el => {
          weeks.forEach(item => {
            valuesToFill.push(`${el}/${item}`)
          })
        })
      } else {
        return { filledData: data, filledLabels: labels }
      }

      valuesToFill.forEach(el => {
        if (data[el]) {
          filledData[el] = data[el]
        } else {
          filledData[el] = []
        }
        if (labels) {
          const index = labels.findIndex(
            item => item[this.labelForChart] === el
          )
          if (index >= 0) {
            filledLabels.push(labels[index])
          } else {
            const filledItem = {}
            filledItem[labelTofill] = el
            filledItem[this.dataForChart] = 0
            filledLabels.push(filledItem)
          }
        }
      })
      if (valueType === 'YearWeek' || valueType === 'MonthYear') {
        const indexes = []
        Object.values(filledData).filter((el, index) => {
          if (el.length > 0) {
            indexes.push(index)
            return true
          }
          return false
        })
        const notEmpty = {
          first: indexes[0],
          last: indexes.slice(-1)[0],
        }
        filledLabels = filledLabels.slice(notEmpty.first, notEmpty.last + 1)
        filledData = Object.fromEntries(
          Object.entries(filledData).slice(notEmpty.first, notEmpty.last + 1)
        )
      }
      return { filledData, filledLabels }
    },

    fillData(event) {
      if (this.colors.length < this.rData.length) {
        let count = this.rData.length - this.colors.length
        let color = randomColor({
          count: count,
          luminosity: 'light',
          hue: 'random',
        })
        this.colors = this.colors.concat(color)
      }

      this.label = []
      this.labelStacked = []
      this.data = []
      this.dataStacked = []
      this.background = []

      let arr = this.reportData
      let chartSettings = {}

      if (!this.label2ForChart) {
        chartSettings = {
          type: this.chartType,
          label: this.labelForChart,
          data: this.dataForChart,
        }
      } else {
        chartSettings = {
          type: this.chartType,
          label: this.labelForChart,
          data: this.dataForChart,
          label2: this.label2ForChart,
        }
      }

      let Charts = {
        setOrder: [
          'warning',
          'danger',
          'success',
          'info',
          'primary',
          'default',
          'first',
          'second',
          'four',
          'five',
          'six',
          'seven',
          'nine',
          'ten',
          'info2',
          'info3',
          'info4',
          'info6',
          'info7',
          'info8',
          'info9',
          'info10',
          'info11',
        ],
        // Colors
        colors: {
          theme: {
            default: '#172b4d',
            success: '#2dce89',
            info: '#11cdef',
            danger: '#f5365c',
            warning: '#fb6340',
            primary: '#5e72e4',
            first: '#fe85d0',
            second: '#f7febd',
            four: '#65fef2',
            five: '#fee0f2',
            six: '#03feb7',
            seven: '#c9fe91',
            nine: '#a465fe',
            ten: '#3f2cfe',
            info2: '#fea8ab',
            info3: '#fe8d61',
            info4: '#9c0965',
            info5: '#ff9f40',
            info6: '#36a2eb',
            info8: '#ff6384',
            info9: '#ffcd56',
            info10: '#4bc0c0',
            info11: '#6f40fe',
          },
        },
      }

      // console.log(1, arr)

      
      // let ans = _(arr)
      //   .groupBy(this.labelForChart)
      //   .map((platform, n) => ({
      //     [this.labelForChart]: n,
      //     [this.dataForChart]: _.sumBy(platform, item =>
      //       Number(item[this.dataForChart])
      //     ),
      //   }))
      //   .value()
      let ans = []
      let arr_level1Grouped = []
      let arr_level1 = {}
      
      if(this.labelForChart){
        if(this.labelForChart != this.dataForChart){
          ans = alasql(`SELECT [${this.labelForChart}] as [${this.labelForChart}], SUM(CAST([${this.dataForChart}] as NUMBER)) as [${this.dataForChart}]  FROM ? GROUP BY [${this.labelForChart}]`, [arr]) 
        }else{
          ans = alasql(`SELECT CAST([${this.labelForChart}] as NUMBER) as [${this.labelForChart}] FROM ? GROUP BY [${this.labelForChart}]`, [arr])
        }
        arr_level1Grouped = alasql(`SELECT ARRAY(_) AS [${this.labelForChart}] FROM ? GROUP BY [${this.labelForChart}]`, [arr])
      }
      
      arr_level1Grouped.forEach(elem => {
        arr_level1[elem[this.labelForChart][0][this.labelForChart]] = elem[this.labelForChart]
      }) 
      // let arr_level1 = _.groupBy(arr, this.labelForChart)
                                           // data, labeles, valueType
      const filledData = this.fillWithEmpty(arr_level1, ans, this.labelForChart)
      arr_level1 = filledData.filledData
      ans = filledData.filledLabels

      console.log(arr_level1, 'arr_level1')
      console.log(ans, 'ans')

      let arr_level2 = map(arr_level1, d => {
        return groupBy(d, this.label2ForChart)
      })
      let arr_level2test = []
      // console.log(arr_level1, 'arr_level1')
      // if(this.labelForChart){
      //   arr_level2test = alasql(`SELECT VALUE  FROM ? GROUP BY [${this.label2ForChart}]`, [arr_level1])
      // }
      

      // console.log(arr_level2test, 'arr_level2test')

      let obgOp = _(arr_level2)
        .map((outer, inner) =>
          map(outer, (data, label) => ({
            [this.label2ForChart]: label,
            [this.dataForChart]: _.sumBy(data, item =>
              Number(item[this.dataForChart])
            ),
          }))
        )
        .value()

      obgOp.map(d => {
        map(d, (data, index) => {
          this.labelStacked.push(
            `${data[this.label2ForChart]} - ${data[this.dataForChart]}`
          )
          this.dataStacked.push(data[this.dataForChart])
        })
      })

      // console.log(obgOp, 'obgOp')

      var $employ_obj_type_barchar_data = {
        labels: Object.keys(arr_level1),
        datasets: [],
      }
      let secondLabel = this.label2ForChart
      let firstLabel = this.labelForChart
      let dataForStacked = this.dataForChart

      forEach(
        this.fillWithEmpty(groupBy(arr, secondLabel), null, secondLabel)
          .filledData,
        function(key, value) {
          let $data = Array(Object.keys(arr_level1).length).fill(0)
          forEach(groupBy(key, firstLabel), function(_key, _index) {
            if (_key.length > 0) {
              $data[Object.keys(arr_level1).indexOf(_index)] = _.sumBy(
                _key,
                item => Number(item[dataForStacked])
              )
              value = `${value} - ${
                $data[Object.keys(arr_level1).indexOf(_index)]
              }`
            } else {
              $data[Object.keys(arr_level1).indexOf(_index)] = _key.length
            }
          })
          $employ_obj_type_barchar_data.datasets.push({
            label: value,
            data: $data,
            backgroundColor:
              Charts.colors.theme[
                Charts.setOrder[$employ_obj_type_barchar_data.datasets.length]
              ],
          })
        }
      )
      this.dataByStacked = $employ_obj_type_barchar_data

      // console.log(4, this.dataByStacked)

      const parseFloatValue = val => {
        if (+val % 1 !== 0) {
          return (+val).toFixed(2)
        } else {
          return val
        }
      }

      ans.map((d, n) => {
        const formatedVal = parseFloatValue(d[this.dataForChart])
        this.label.push(`${d[this.labelForChart]} - ${formatedVal}`)
        this.labellabel.push(d[this.labelForChart])
        this.data.push(d[this.dataForChart])
      })

      const singleLineDatasets = [
        {
          label: this.dataForChart,
          data: this.data,
          borderColor: '#5e72e4',
          fill: false,
          pointRadius: 4,
        },
      ]

      const multiLineDatasets = [...this.dataByStacked.datasets].map(
        el => {
          return {
            ...el,
            borderColor: el.backgroundColor,
            fill: false,
            pointRadius: 4,
          }
        }
      )

      // console.log(5, singleLineDatasets, multiLineDatasets)

      const addStylesForAreaChart = config => {
        return config.map(x => {
          x.fill = true
          x.borderColor = 'transparent'
          x.backgroundColor = x.backgroundColor + '8c'
          x.pointBorderColor = x.backgroundColor
          x.pointHoverBorderColor = x.backgroundColor
          x.pointHoverBackgroundColor = x.backgroundColor
          x.borderWidth = 1
          x.pointBackgroundColor = x.backgroundColor
          x.pointHoverRadius = 5
          x.pointHoverBorderWidth = 7
          x.pointRadius = 0
          x.pointHitRadius = 30
          return x
        })
      }

      const pickData = () => {
        let result
        if (this.labelForChart === this.label2ForChart) {
          result = singleLineDatasets
        } else {
          result = multiLineDatasets
        }
        if (this.chartType === 'area') {
          return addStylesForAreaChart(result)
        }
        return result
      }

      this.dataByLine = {
        labels: this.label,
        datasets: pickData(),
      }
      this.optionsByLine = {
        plugins: {
          datalabels: {
            display: false,
            backgroundColor: function(context) {
              return context.dataset.backgroundColor
            },
            borderRadius: 4,
            color: 'white',
            font: {
              weight: 'bold',
            },
            formatter: Math.round,
          },
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                borderDash: [2],
                borderDashOffset: [2],
                color: '#dee2e6',
                drawBorder: false,
                drawTicks: false,
                lineWidth: 0,
                zeroLineWidth: 0,
                zeroLineColor: '#dee2e6',
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
              ticks: {
                fontColor: '#8898aa',
                beginAtZero: true,
                padding: 10,
                callback: function(value) {
                  if (value % 1 === 0) {
                    return value
                  }
                },
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                drawBorder: false,
                drawOnChartArea: false,
                drawTicks: false,
              },
              ticks: {
                autoSkip: false,
                fontColor: '#8898aa',
                padding: 20,
                beginAtZero: false,
              },
            },
          ],
        },
        legend: {
          ...this.legend,
          display: true,
        },
      }
      this.optionsByTable = {
        columnLabelName: this.labelForChart,
        columnValueName: this.dataForChart,
      }
      this.dataByDefualt = {
        labels: this.label,
        datasets: [
          {
            label: this.dataForChart,
            data: this.data,
            backgroundColor: this.colors,
          },
        ],
      }
      this.optionsByPie = {
        scales: {
          yAxes: [
            {
              display: false,
            },
          ],
          xAxes: [
            {
              display: false,
            },
          ],
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: (tooltipItems, data) => {
              return data['labels'][tooltipItems['index']]
            },
          },
        },
        plugins: {
          datalabels: {
            color: 'white',
            display: false,
            font: {
              weight: 'bold',
            },
            formatter: Math.round,
          },
        },
        legend: {
          display: true,
          fullWidth: false,
          position: 'top',
          labels: {
            fontColor: '#8898aa',
            usePointStyle: true,
            padding: 10,
          },
        },
      }

      this.optionsByDonut = {
        cutoutPercentage: 83,
        scales: {
          yAxes: [
            {
              display: false,
            },
          ],
          xAxes: [
            {
              display: false,
            },
          ],
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: (tooltipItems, data) => {
              return data['labels'][tooltipItems['index']]
            },
          },
        },
        plugins: {
          datalabels: {
            color: 'black',
            display: false,
            font: {
              weight: 'bold',
            },
            formatter: Math.round,
          },
        },
        legend: {
          display: true,
          fullWidth: false,
          position: 'top',
          labels: {
            fontColor: '#8898aa',
            usePointStyle: true,
            padding: 10,
          },
        },
      }

      this.optionsByStacked = {
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                drawBorder: false,
                drawOnChartArea: false,
                drawTicks: false,
              },
              ticks: {
                autoSkip: false,
                fontColor: '#8898aa',
                padding: 20,
              },
              barPercentage: 0.7,
              maxBarThickness: 15,
            },
          ],
          yAxes: [
            {
              stacked: true,
              gridLines: {
                borderDash: [2],
                borderDashOffset: [2],
                color: '#dee2e6',
                drawBorder: false,
                drawTicks: false,
                lineWidth: 0,
                zeroLineWidth: 0,
                zeroLineColor: '#dee2e6',
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
              ticks: {
                fontColor: '#8898aa',
                beginAtZero: true,
                padding: 10,
                callback: function(value) {
                  if (!(value % 10)) {
                    return value
                  }
                },
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            display: function(context) {
              return context.dataset.data[context.dataIndex] > 15
            },
            display: false,
            color: 'white',
            font: {
              weight: 'bold',
            },
            formatter: Math.round,
          },
        },
        legend: {
          ...this.legend,
          display: true,
        },
      }
      this.optionsByBar = {
        scales: {
          yAxes: [this.yAxes],
          xAxes: [this.xAxes],
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: (tooltipItems, data) => {
              return ''
            },
          },
        },
        plugins: {
          datalabels: {
            display: false,
            color: 'white',
            font: {
              weight: 'bold',
            },
            formatter: Math.round,
          },
        },
        legend: {
          ...this.legend,
          display: true,
        },
      }
      this.optionsByMultiple = {
        responsive: true,
        scales: {
          yAxes: [this.yAxes],
          xAxes: [this.xAxes],
        },
        plugins: {
          datalabels: {
            display: false,
            align: 'center',
            anchor: 'center',
            font: { weight: 'bold' },
          },
        },
        legend: {
          ...this.legend,
          display: true,
        },
      }
    },
    setActive(activeChart) {
      this.chartType = activeChart
      this.isPie = activeChart === 'pie' ? true : false
      this.isDonut = activeChart === 'donut' ? true : false
      this.isBar = activeChart === 'bar' ? true : false
      this.isStacked = activeChart === 'stacked' ? true : false
      this.isLine = activeChart === 'line' ? true : false
      ;(this.isMultiple = activeChart === 'multiple' ? true : false),
        (this.isTable = activeChart === 'table' ? true : false),
        db.chart.setActiveChartType(this.chartId, this.chartType)
    },
  },
  created() {
    this.fillData()
  },
  async mounted() {
    const widgetInst = this.$instByClass(this, 'widgetContent')

    const chartOptions = await db.chart.readOptions(
      this.chartId,
      widgetInst.widget.inherited ? this.currentTemplate : null
    )

    this.chartType = chartOptions.type
    this.dataForChart = chartOptions.data
    this.labelForChart = chartOptions.label
    this.label2ForChart = chartOptions.label2
    this.filterByDropdown()
    this.loadData()
    this.isReady = true

    this.adjustChartSize()
  },
}
</script>

<style lang="scss">
.chartWidget {
  height: 100%;

  &__chartWrapper {
    position: relative;
    left: 30px;
    top: 0;
    width: calc(100% - 60px);
    height: 100%;
    > div {
      height: 100%;
    }
  }

  &__settingsShowTrigger {
    z-index: 1;
    position: absolute;
    height: 25px;
    right: 15px;
    top: 25px;
  }

  &__settings {
    position: relative;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 1;
    overflow: auto;
    margin: 0;
  }

  &__settingsHideTrigger {
    position: absolute;
    right: 5px;
    top: 3px;
    width: 13px;
    height: 16px;
    line-height: 1;

    svg {
      vertical-align: 6px;
    }
  }
}
</style>
